<template>
    <div class="products_page">
        <div class="section section__main"> 
            <div class="uk-container uk-container-large">
                <div class="section__navigation">
                        <p><span><a href="/">Главная</a> |</span> О продукции</p>
                </div>
                <div class="products_main_block">
                    <div class="products_block">
                        <div class="products_block_left">
                            <div class="products_block_left_item" v-for="(article, index) in leftColumn" :key="index">
                                <router-link class="products-link" :to="articlePath(article.link)">{{ (article.title || '').toUpperCase() }}</router-link>
                            </div>
                            
                        </div>
                        <ul uk-accordion class="products_block_right">
                            <li class="" v-for="(article, index) in rightColumn" :key="index">
                                <a class="uk-accordion-title" href="#">{{ (article.title || '').toUpperCase() }}</a>
                                <div class="uk-accordion-content" v-html="article.description"></div>
                            </li>
                        </ul>
                    </div>
                </div>     
            </div>
        </div> 
    </div>   
</template>

<script>
import { metaFromSeo } from '@/seo/metaFromSeo'

import utils from '../utils';

export default {
  props: {
    isDevice: null,
  },
  data() {
    return {
        leftColumn: [],
        rightColumn: []
    };
  },
  methods: {
    articlePath(link) {
      const base = String(this.$route.path || '/').replace(/\/+$/, '') || ''
      let suffix = String(link || '').trim()
      if (!suffix) {
        return base || '/'
      }
      if (/^https?:\/\//i.test(suffix)) {
        try {
          suffix = new URL(suffix).pathname
        } catch (e) {
          suffix = suffix.replace(/^https?:\/\/[^/]+/i, '')
        }
      }
      suffix = suffix.replace(/^\/+|\/+$/g, '')
      const baseKey = base.replace(/^\/+/, '')
      if (!suffix) {
        return base || '/'
      }
      if (suffix === baseKey || suffix.startsWith(`${baseKey}/`)) {
        return `/${suffix}`
      }
      return `${base}/${suffix}`
    },
    fetchData: async function() {
        const { fetchApi, BRAND_ID, BRAND_SLUG } = utils();
        const response = await fetchApi('news/public', {
          params: {
            brand_id: BRAND_ID,
            brand_slug: BRAND_SLUG,
            type: 'О продукции',
            limit: 100,
          },
        });
        const rows = response && Array.isArray(response.data) ? response.data : [];
        const byIdAsc = (a, b) => (a.id ?? 0) - (b.id ?? 0)
        this.leftColumn = rows
          .filter(article => article.link && String(article.link).length > 0)
          .sort(byIdAsc)
        this.rightColumn = rows
          .filter(article => !article.link || String(article.link).length === 0)
          .sort(byIdAsc)
    },
    resizeHeaderTheme() {
      if (this.isDevice === 'desktop') {
        this.$emit('updateHeaderTheme', {theme: 'light'})
      }
    },
  },
  watch: {
    isDevice() {
      this.resizeHeaderTheme()
    },
  },
  metaInfo() {
    return metaFromSeo({
      title: 'О продукции',
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
    })
  },
  mounted() {
    this.resizeHeaderTheme()
    this.fetchData()
  }
};
</script>